import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import {
    PassBusinessRequest,
    PassBusinessResponse,
    PassBusinessGroupedResponse
} from '../models/pass-business.model';
import { ResponseObject } from '../models/response-object.model';

@Injectable({
    providedIn: 'root'
})
export class PassBusinessService {

    private URL = environment.api + 'api/passBusiness';

    constructor(
        private http: HttpClient
    ) { }

    getVisiblePassBusiness() {
        return this.http.get<ResponseObject>(
            this.URL + '/visible'
        );
    }

    savePassBusiness(request: PassBusinessRequest) {
        return this.http.post<ResponseObject>(
            this.URL + '/save',
            request
        );
    }

    updatePassBusiness(request: PassBusinessRequest) {
        return this.http.post<ResponseObject>(
            this.URL + '/update',
            request
        );
    }

    deletePassBusiness(id: number) {
        return this.http.post<ResponseObject>(
            this.URL + '/delete/' + id,
            {}
        );
    }
}